import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {WorkRegionModel} from '../../models/configuration/nonWorkingDays/work-region.model';
import {Observable} from 'rxjs/Observable';
import {NonWorkingDaysModel} from '../../models/configuration/nonWorkingDays/non-working-days.model';
import {NonWorkingDayModel} from '../../models/configuration/nonWorkingDays/non-working-day.model';

@Injectable({
  providedIn: 'root'
})
export class NonWorkingDaysService {
  private baseRouteToController: string = 'api/non-working-day';

  constructor(private httpClient: HttpClient) { }

  getScheduleNonWorkingRegions(): Observable<WorkRegionModel[]> {
    return this.httpClient.get<WorkRegionModel[]>(`${this.baseRouteToController}/region-names`);
  }

  createScheduleNonWorking(regionName: string) {
    return this.httpClient.post<any>(`${this.baseRouteToController}`, { RegionName: regionName });
  }

  getScheduleNonWorking(workRegionID: string): Observable<NonWorkingDaysModel> {
    return this.httpClient.get<NonWorkingDaysModel>(`${this.baseRouteToController}/${workRegionID}`);
  }

  getYears(regionId: string): Observable<NonWorkingDayModel[]> {
    return this.httpClient.get<NonWorkingDayModel[]>(`api/non-working-day/get-years/${regionId}`);
  }

  saveYears(models: NonWorkingDayModel[]): Observable<NonWorkingDayModel[]> {
    return this.httpClient.post<NonWorkingDayModel[]>(`${this.baseRouteToController}/save-years`, models);
  }

  updateScheduleNonWorkingDay(workRegionID: string, enumCountryID: string, nonWorkingDaysToAdd: NonWorkingDayModel[]) {
    console.log('test');
    const obs = this.httpClient.post<any>(`${this.baseRouteToController}/${workRegionID}/${enumCountryID}`, nonWorkingDaysToAdd);
    console.log('test');
    return obs;
  }

  deleteRegion(model: WorkRegionModel) {
    return this.httpClient.post<any>(`${this.baseRouteToController}/delete-region`, model);
  }

  deleteDaysByYear(regionId: string, year: number) {
    return this.httpClient.get<any>(`${this.baseRouteToController}/delete-days-by-year/${regionId}/${year}`);
  }
}
